
//Type of proposal (Tipo de propuesta)
export const typeProposal = {
    '-1': '--',
    0: '--',
    1: 'A1 I',
    2: 'A1 II',
    3: 'A2',
    4: 'A3',
    5: 'A4',
};